import { numberWithCommas as numberWithCommasDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type FormatNumberProps = {
    count: number;
}

export const formatNumber = ({ count }: FormatNumberProps): string =>
    numberWithCommasDiagram(count);
